import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { SupplierGrid } from "../components/SupplierGrid";
import { HowItWorks } from "../components/HowItWorks";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <main className="bg-[#09040E] text-white overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <SupplierGrid />
      <HowItWorks />
      <Footer />
    </main>
  );
}
